import { clsx } from 'clsx';
import { Label as LabelPrimitive } from 'radix-ui';
import type { ComponentPropsWithoutRef } from 'react';

export interface LabelProps extends ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  /** Adds a visual "*" (decorative — put `required` on the control for assistive tech). */
  required?: boolean;
}

/** Always-visible field label (never a placeholder substitute). */
export function Label({ required, className, children, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root className={clsx('label', className)} {...props}>
      {children}
      {required ? (
        <span className="label__mark" aria-hidden="true">
          *
        </span>
      ) : null}
    </LabelPrimitive.Root>
  );
}
